const Divider = () => (
  <hr data-testid='divider' className='m-0 h-px border-0 bg-grey-l2' />
);

export default Divider;
